export function betweenMatcherContext(ruleVO) {
  return function betweenMatcher(runtimeAttr) {
    var isBetween = runtimeAttr >= ruleVO.start && runtimeAttr <= ruleVO.end;
    return isBetween;
  };
}